import { parseISO } from 'date-fns';
import { format, toZonedTime } from 'date-fns-tz';

// Função para formatar data em um timezone específico
export const formatDateToTimezone = (dateTime: string, timezone: string) => {
  const date = parseISO(dateTime);
  const zonedDate = toZonedTime(date, timezone);
  const formattedDate = format(zonedDate, 'yyyy-MM-dd\'T\'HH:mm:ss', { timeZone : timezone });
  return formattedDate;
};

// Hook para formatar data considerando o timezone dinâmico
export const useFormattedDateTimeZone = () => {

  const formatDate = (dateTime: string, timeZone: string) => {
    const formattedDateTime = formatDateToTimezone(dateTime, timeZone);
    return parseISO(formattedDateTime);
  };

  const handleFormatedDate = (datetime: string, locale: string, timezone: string) => {
    const hourFormat = locale === 'en-US' ? 'hh\':\'mm a' : 'HH\':\'mm';
    const dateFormat = locale === 'en-US' ? 'EEEE, MMMM dd' : 'EEEE, dd \'de\' MMMM';
    const adjustedDate = formatDate(datetime, timezone);

    return format(adjustedDate, `${dateFormat} ' - ' ${hourFormat}'`);
  };

  return { formatDate, handleFormatedDate };
};

export default useFormattedDateTimeZone;
